import { useEffect } from 'react'

import { useScrollParentRef } from '@subaio/components'
import type { Page } from '@subaio/utils'

import { Container } from './Container'
import { Link } from './Link'

type Props = {
	title: string
	name: string
	params?: Page['params']
	id: string
	isActive: boolean
}

export const Entry = ({ title, name, params, id, isActive }: Props) => {
	const scrollParentRef = useScrollParentRef()

	useEffect(() => {
		if (!isActive || !scrollParentRef.current) return

		scrollParentRef.current.scrollIntoView({
			behavior: 'smooth',
			clearance: 0.25,
		})
	}, [isActive, scrollParentRef])

	return (
		<Container ref={scrollParentRef}>
			<Link name={name} params={params} fragment={id} activeMatch='exact' isActive={isActive} replace>
				{title}
			</Link>
		</Container>
	)
}
